import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import NotFound from './components/NotFound';
import Home from './components/Home';
import AboutMe from './components/AboutMe';
import Frequency from './components/Frequency';
import CohablistHome from './components/CohablistHome';
import CohablistPrivacy from './components/CohablistPrivacy';
import CohablistTerms from './components/CohablistTerms';
import CohablistDeletion from './components/CohablistDeletion';
import CruHome from './components/CruHome';
import CruPrivacy from './components/CruPrivacy';
import CruTerms from './components/CruTerms';

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/frequency" element={<Frequency />} />
        {/* hidden — not linked from anywhere */}
        <Route path="/aboutme" element={<AboutMe />} />
        <Route path="/cohablist" element={<CohablistHome />} />
        <Route path="/cohablist/privacy" element={<CohablistPrivacy />} />
        <Route path="/cohablist/tos" element={<CohablistTerms />} />
        <Route path="/cohablist/delete" element={<CohablistDeletion />} />
        <Route path="/cru" element={<CruHome />} />
        <Route path="/cru/privacy" element={<CruPrivacy />} />
        <Route path="/cru/tos" element={<CruTerms />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
